import { fetcher } from "@website/fetcher/fetcher";
import { TELESALES_API_URL } from "@website/widget/telesales/constants";
import { TelesalesRequest } from "@website/widget/telesales/telesales-form/types";
import { useCallback, useState } from "react";

export const useSendToTelesales = () => {
  const [isPending, setIsPending] = useState(false);
  const mutateAsync = useCallback(async (data: TelesalesRequest) => {
    setIsPending(true);
    try {
      await fetcher({
        url: TELESALES_API_URL,
        method: "POST",
        data
      }).then(({ data }: { data: { redirectUrl: string } }) => data);
    } finally {
      setIsPending(false);
    }
  }, []);

  return {
    mutateAsync,
    isPending
  };
};
